import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-submenu",
  "use": "icon-submenu-usage",
  "viewBox": "0 0 1 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1 15\" id=\"icon-submenu\">\r\n\t<rect y=\"0\" class=\"st0\" width=\"1\" height=\"15\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol